import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ConversationPanel = ({ activeChannel }) => {
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messageText, setMessageText] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const conversations = [
  {
    id: 1,
    clientName: 'أحمد محمد السعيد',
    clientImage: "https://img.rocket.new/generatedImages/rocket_gen_img_124f29a0c-1763295911925.png",
    clientImageAlt: 'صورة شخصية لرجل عربي يرتدي بدلة رسمية زرقاء داكنة مع قميص أبيض وربطة عنق',
    lastMessage: 'شكراً على المعلومات، متى يمكنني زيارة العقار؟',
    timestamp: new Date(Date.now() - 300000),
    unread: true,
    status: 'active',
    propertyInterest: 'فيلا فاخرة - حي النرجس'
  },
  {
    id: 2,
    clientName: 'فاطمة علي الزهراني',
    clientImage: "https://images.unsplash.com/photo-1582511759050-2494ae9e48c0",
    clientImageAlt: 'صورة شخصية لامرأة عربية محجبة ترتدي حجاب أزرق فاتح مع ابتسامة دافئة',
    lastMessage: 'هل العقار متاح للمعاينة هذا الأسبوع؟',
    timestamp: new Date(Date.now() - 900000),
    unread: true,
    status: 'pending',
    propertyInterest: 'شقة عائلية - حي الياسمين'
  },
  {
    id: 3,
    clientName: 'خالد عبدالله القحطاني',
    clientImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1b4710b43-1763294093140.png",
    clientImageAlt: 'صورة شخصية لرجل عربي يرتدي ثوب أبيض تقليدي مع غترة وعقال',
    lastMessage: 'تم استلام العقد، سأراجعه وأرد عليكم قريباً',
    timestamp: new Date(Date.now() - 3600000),
    unread: false,
    status: 'contract',
    propertyInterest: 'مكتب تجاري - برج الأعمال'
  },
  {
    id: 4,
    clientName: 'نورة سعد المطيري',
    clientImage: "https://images.unsplash.com/photo-1641464743937-06272de7bb85",
    clientImageAlt: 'صورة شخصية لامرأة عربية محجبة ترتدي حجاب بيج مع نظارات طبية',
    lastMessage: 'ما هي شروط الدفع المتاحة؟',
    timestamp: new Date(Date.now() - 7200000),
    unread: false,
    status: 'negotiation',
    propertyInterest: 'شقة استثمارية - حي الربوة'
  },
  {
    id: 5,
    clientName: 'محمد سالم العتيبي',
    clientImage: "https://img.rocket.new/generatedImages/rocket_gen_img_16a507d98-1763294547027.png",
    clientImageAlt: 'صورة شخصية لرجل عربي يرتدي بدلة رمادية مع قميص أزرق فاتح',
    lastMessage: 'شكراً لكم، سأتواصل معكم بعد مناقشة الأمر مع عائلتي',
    timestamp: new Date(Date.now() - 86400000),
    unread: false,
    status: 'follow_up',
    propertyInterest: 'فيلا دوبلكس - حي الورود'
  }];


  const messages = selectedConversation ? [
  {
    id: 1,
    sender: 'client',
    text: 'السلام عليكم، أنا مهتم بالعقار المعروض في حي النرجس',
    timestamp: new Date(Date.now() - 7200000),
    status: 'read'
  },
  {
    id: 2,
    sender: 'staff',
    text: 'وعليكم السلام ورحمة الله وبركاته\nأهلاً وسهلاً بك، يسعدنا اهتمامك بالعقار\nالعقار عبارة عن فيلا فاخرة بمساحة 500 متر مربع مع حديقة خاصة',
    timestamp: new Date(Date.now() - 7000000),
    status: 'read'
  },
  {
    id: 3,
    sender: 'client',
    text: 'ممتاز، ما هو السعر المطلوب؟',
    timestamp: new Date(Date.now() - 6800000),
    status: 'read'
  },
  {
    id: 4,
    sender: 'staff',
    text: 'السعر المطلوب 2,500,000 ريال سعودي\nمتاح للتفاوض حسب طريقة الدفع',
    timestamp: new Date(Date.now() - 6600000),
    status: 'read',
    aiSuggested: true
  },
  {
    id: 5,
    sender: 'client',
    text: 'شكراً على المعلومات، متى يمكنني زيارة العقار؟',
    timestamp: new Date(Date.now() - 300000),
    status: 'delivered'
  }] :
  [];

  const aiSuggestions = [
  'يمكننا ترتيب موعد للمعاينة في أي وقت يناسبك خلال الأسبوع القادم',
  'العقار متاح للمعاينة يومياً من الساعة 9 صباحاً حتى 6 مساءً',
  'سأقوم بتنسيق موعد المعاينة وإرسال تفاصيل الموقع لك'];


  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = now?.getTime() - date?.getTime();
    const minutes = Math.floor(diff / 60000);

    if (minutes < 60) return `منذ ${minutes} دقيقة`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `منذ ${hours} ساعة`;
    const days = Math.floor(hours / 24);
    if (days === 1) return 'أمس';
    if (days < 7) return `منذ ${days} أيام`;
    return date?.toLocaleDateString('ar-SA');
  };

  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-success',
      pending: 'bg-warning',
      contract: 'bg-primary',
      negotiation: 'bg-accent',
      follow_up: 'bg-secondary'
    };
    return colors?.[status] || 'bg-muted';
  };

  const getStatusLabel = (status) => {
    const labels = {
      active: 'نشط',
      pending: 'قيد الانتظار',
      contract: 'مرحلة العقد',
      negotiation: 'تفاوض',
      follow_up: 'متابعة'
    };
    return labels?.[status] || status;
  };

  const filteredConversations = conversations?.filter((conv) =>
  conv?.clientName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
  conv?.propertyInterest?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleSendMessage = () => {
    if (messageText?.trim()) {
      console.log('Sending message:', messageText);
      setMessageText('');
    }
  };

  return (
    <div className="h-full flex flex-col lg:flex-row bg-card">
      {/* Conversations List */}
      <div className="w-full lg:w-2/5 border-l border-border flex flex-col">
        <div className="p-4 md:p-6 border-b border-border">
          <div className="flex items-center justify-between mb-3 md:mb-4">
            <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
              المحادثات
            </h3>
            <Button variant="ghost" size="icon" iconName="Filter" iconSize={18} />
          </div>
          <Input
            type="search"
            placeholder="البحث في المحادثات..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="w-full" />

        </div>

        <div className="flex-1 overflow-y-auto">
          {filteredConversations?.map((conversation) =>
          <button
            key={conversation?.id}
            onClick={() => setSelectedConversation(conversation?.id)}
            className={`w-full p-3 md:p-4 border-b border-border hover:bg-muted transition-all duration-250 text-right ${
            selectedConversation === conversation?.id ? 'bg-muted' : ''}`
            }>

              <div className="flex items-start gap-2 md:gap-3">
                <div className="relative flex-shrink-0">
                  <Image
                  src={conversation?.clientImage}
                  alt={conversation?.clientImageAlt}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" />

                  {conversation?.unread &&
                <div className="absolute -top-1 -left-1 w-3 h-3 md:w-4 md:h-4 bg-error rounded-full border-2 border-card" />
                }
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h4 className="text-sm md:text-base font-medium text-foreground truncate">
                      {conversation?.clientName}
                    </h4>
                    <span className="text-xs text-muted-foreground font-caption whitespace-nowrap mr-2">
                      {formatTimestamp(conversation?.timestamp)}
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-muted-foreground line-clamp-1 mb-1 md:mb-2">
                    {conversation?.lastMessage}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-caption text-white ${getStatusColor(conversation?.status)}`}>
                      {getStatusLabel(conversation?.status)}
                    </span>
                    <span className="text-xs text-muted-foreground truncate font-caption">
                      {conversation?.propertyInterest}
                    </span>
                  </div>
                </div>
              </div>
            </button>
          )}
        </div>
      </div>
      {/* Messages Area */}
      <div className="flex-1 flex flex-col">
        {selectedConversation ?
        <>
            {/* Chat Header */}
            <div className="p-4 md:p-6 border-b border-border bg-muted/30">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 md:gap-3">
                  <Image
                  src={conversations?.find((c) => c?.id === selectedConversation)?.clientImage}
                  alt={conversations?.find((c) => c?.id === selectedConversation)?.clientImageAlt}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" />

                  <div>
                    <h4 className="text-sm md:text-base font-heading font-semibold text-foreground">
                      {conversations?.find((c) => c?.id === selectedConversation)?.clientName}
                    </h4>
                    <p className="text-xs md:text-sm text-muted-foreground font-caption">
                      {conversations?.find((c) => c?.id === selectedConversation)?.propertyInterest}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Button variant="ghost" size="icon" iconName="Phone" iconSize={18} />
                  <Button variant="ghost" size="icon" iconName="Video" iconSize={18} />
                  <Button variant="ghost" size="icon" iconName="MoreVertical" iconSize={18} />
                </div>
              </div>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-3 md:space-y-4">
              {messages?.map((message) =>
            <div
              key={message?.id}
              className={`flex ${message?.sender === 'staff' ? 'justify-start' : 'justify-end'}`}>

                  <div className={`max-w-[85%] md:max-w-[70%] ${message?.sender === 'staff' ? 'order-2' : 'order-1'}`}>
                    <div
                  className={`p-3 md:p-4 rounded-lg ${
                  message?.sender === 'staff' ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'}`
                  }>

                      <p className="text-sm md:text-base whitespace-pre-line">{message?.text}</p>
                      {message?.aiSuggested &&
                  <div className="flex items-center gap-1 mt-2 text-xs opacity-70">
                          <Icon name="Bot" size={12} />
                          <span>مقترح بواسطة الذكاء الاصطناعي</span>
                        </div>
                  }
                    </div>
                    <div className="flex items-center gap-2 mt-1 px-1">
                      <span className="text-xs text-muted-foreground font-caption">
                        {formatTimestamp(message?.timestamp)}
                      </span>
                      {message?.sender === 'staff' &&
                  <Icon
                    name={message?.status === 'read' ? 'CheckCheck' : 'Check'}
                    size={14}
                    className={message?.status === 'read' ? 'text-primary' : 'text-muted-foreground'} />

                  }
                    </div>
                  </div>
                </div>
            )}
            </div>

            {/* AI Suggestions */}
            {aiSuggestions?.length > 0 &&
          <div className="p-3 md:p-4 border-t border-border bg-muted/30">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Bot" size={16} className="text-primary" />
                  <span className="text-xs md:text-sm font-caption text-muted-foreground">
                    ردود مقترحة بالذكاء الاصطناعي
                  </span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {aiSuggestions?.map((suggestion, index) =>
              <button
                key={index}
                onClick={() => setMessageText(suggestion)}
                className="px-3 py-1.5 md:px-4 md:py-2 rounded-lg bg-card border border-border hover:bg-primary hover:text-primary-foreground transition-all duration-250 text-xs md:text-sm text-right">

                      {suggestion}
                    </button>
              )}
                </div>
              </div>
          }

            {/* Message Input */}
            <div className="p-4 md:p-6 border-t border-border">
              <div className="flex items-end gap-2 md:gap-3">
                <Button variant="ghost" size="icon" iconName="Paperclip" iconSize={20} />
                <Button variant="ghost" size="icon" iconName="Smile" iconSize={20} />
                <Input
                type="text"
                placeholder="اكتب رسالتك هنا..."
                value={messageText}
                onChange={(e) => setMessageText(e?.target?.value)}
                onKeyPress={(e) => e?.key === 'Enter' && handleSendMessage()}
                className="flex-1" />

                <Button
                variant="default"
                onClick={handleSendMessage}
                disabled={!messageText?.trim()}
                iconName="Send"
                iconSize={20}>

                  إرسال
                </Button>
              </div>
            </div>
          </> :

        <div className="flex-1 flex items-center justify-center p-8">
            <div className="text-center">
              <Icon name="MessageSquare" size={64} className="text-muted-foreground mx-auto mb-4" />
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
                اختر محادثة للبدء
              </h3>
              <p className="text-sm md:text-base text-muted-foreground font-caption">
                حدد محادثة من القائمة لعرض الرسائل والرد على العملاء
              </p>
            </div>
          </div>
        }
      </div>
    </div>);

};

export default ConversationPanel;